
import './assets/scss/var.css'
import './assets/scss/var-font-1.css'
import './assets/scss/var-font-2.css'
import './assets/scss/var-theme-1.css'
import './assets/scss/var-theme-2.css'
import './assets/scss/var-theme-3.css'
import './assets/scss/var-theme-4.css'

import './assets/scss/init/index.scss'
// import './icon/icon.js'

// 引入工具库
import './js/index.js'

import './vue/index.js'


// 设置全局vant popup弹窗在页面回退时默认关闭
vant.Popup.props.closeOnPopstate = {
  default: true
};

// 设置全局vant ActionSheet动作面板在页面回退时默认关闭 
vant.ActionSheet.props.closeOnPopstate.default = true;

// 设置日历组件 周起始日 默认从周一开始
vant.Calendar.props.firstDayOfWeek.default = 1;

// 设置下拉刷新组件，下拉高度为96时刷新
vant.PullRefresh.props.headHeight.default = 96;



//css变量切换
app._cssVar = {};
let classThemeName = '',
    classFontName = '';
app._cssVar.themeChange = (index,save)=>{
  classThemeName && app.dom.removeClass(document.documentElement,classThemeName);  
  classThemeName = index ? 'theme-' + index : '';
  classThemeName && app.dom.addClass(document.documentElement, classThemeName);
  save && setTheme(index);
};
app._cssVar.fontChange = (index,save)=>{
  classFontName && app.dom.removeClass(document.documentElement,classFontName);  
  classFontName = index ? 'font-' + index : '';
  classFontName && app.dom.addClass(document.documentElement, classFontName);
  save && setFont(index);
}

function getTheme(){
  return app.ls.getStorage('cssvar-theme') || 0;
}
function setTheme(type=0){
  return app.ls.setStorage('cssvar-theme',type);
}

function getFont(){
  return app.ls.getStorage('cssvar-font') || 0;
}
function setFont(type=0){
  return app.ls.setStorage('cssvar-font',type);
}
app._cssVar.getTheme = getTheme;
app._cssVar.getFont = getFont;

app._cssVar.themeChange(app._cssVar.getTheme());
app._cssVar.fontChange(app._cssVar.getFont());